import { client } from "./client";

export async function sendStartButtonMetric(token: string): Promise<void> {
	await client.post(
		`/${process.env.REACT_APP_API_KEY}t179r/json/v2`,
		{
			parameters: {
				public_id: token,
			},
		},
		{
			headers: {
				Function: "SelfRegistrationButtonStart",
			},
		}
	);
}

export async function sendFactpitStartButtonMetric(token: string): Promise<void> {
	await client.post(
		`/${process.env.REACT_APP_API_KEY}t179r/json/v2`,
		{
			parameters: {
				public_id: token,
			},
		},
		{
			headers: {
				Function: "SelfRegistrationFactpitStart",
			},
		}
	);
}
